import { render, staticRenderFns } from "./ChangeLogsList.vue?vue&type=template&id=ff74173a&"
import script from "./ChangeLogsList.vue?vue&type=script&lang=js&"
export * from "./ChangeLogsList.vue?vue&type=script&lang=js&"
import style0 from "./ChangeLogsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports